.frameMenu {
  width: 304px;
  background: var(--theme-primary-background);
  border-radius: 4px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.frameMenuContent {
  padding: var(--spacer-3);
}

.frameMenuSection {
  margin-bottom: var(--spacer-5);
}

.frameMenuSection:last-child {
  margin-bottom: 0;
}

.frameMenuSectionHeading {
  font-size: 13px;
  font-weight: 500;
  color: var(--theme-secondary-text);
  margin-bottom: 10px;
  cursor: pointer !important;
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
  color: var(--theme-secondary-text);
  padding: var(--spacer-1) 0 var(--spacer-1) var(--spacer-1);
  user-select: none;
  line-height: 100%;
}

.frameMenuSectionContent {
  display: flex;
  flex-wrap: wrap;
}

.frameMenuButton {
  border: 1px solid var(--theme-light-border);
  border-radius: 4px;
  cursor: pointer;
  flex-direction: column;
  font-size: 10px;
  width: 62px;
  height: 55px;
  gap: var(--spacer-1);
}

.frameMenuButtonLabel {
  line-height: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--theme-tertiary-text);
}
